module.exports = __webpack_public_path__ + "img/banner3.19e34b3.jpg";